import React, { Component } from 'react';
import { connect } from 'react-redux';
import { path } from 'ramda';
import { push } from 'react-router-redux';
import Table from '../../сomponents/Table';
import Breadcrumbs from '../../common/Breadcrumbs';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import { fetchUsers, removeUser } from '../../api/users';
import { loginUserById } from '../../api/auth';
import './style.css';
import Preloader from "../../common/Preloader";
import hasAccess from "../../helpers/permissionChecker";

export class People extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.handlerView = this.handlerView.bind(this);
    this.addUser = this.addUser.bind(this);
    this.handlerLogin = this.handlerLogin.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      loading: true,
      currentPage: 0,
    };

    this.columns = [
      'id',
      'type',
      'username',
      'firstname',
      'lastname',
      'email',
    ];

    this.columnNames = [
      'Id',
      'Type',
      'Username',
      'Firstname',
      'Lastname',
      'Email',
    ];
  }

  addUser() {
    this.props.addNewUser();
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  componentDidUpdate() {
    const { loading } = this.state;
    const itemList = path(['users', 'userList'], this.props);
    if (loading && itemList) {
      this.setState({ loading: false });
    }
  }

  componentWillMount() {
    this.props.list();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: removeUser,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'remove_user',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  handlerView() {
    this.props.moveToView();
  }

  handlerLogin(id) {
    let data = null;
    if (id) {
      const users = path(['users', 'userList'], this.props) || [];

      for (let i = users.length; i--;) {
        if (users[i].id == id) {
          data = users[i];
        }
      }
    }
    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      handler: this.props.loginAs,
      id: id,
      data: data,
      modalId: 'login_as',
    });
  }

  render() {
    const itemList = path(['users', 'userList'], this.props);
    const { loading } = this.state;
    const itemActions = {
      login: {
        handler: this.handlerLogin,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-child icon-stack-1x'],
        iconClass: '',
        permission: { 'permAreaKey': 'user', 'permTypeKey': 'loginAs' },
        context: this,
        hasWrapper: true,
        title: 'login',
      },
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        authorColumnName: 'user_id',
        permission: { 'permAreaKey': 'user', 'permTypeKey': 'delete' },
        handler: this.handlerDelete,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    const mainPart = loading ? <Preloader show={true} type='circle'/> :
      <Table
        items={itemList}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        actions={itemActions}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
      />;

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'accessibility', name: 'People' },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            People
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'user', 'permTypeKey': 'create' }) &&
            <div className="clearfix mb-3">
              <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addUser}>
                <i className="material-icons">add_circle_outline</i>
                <span className="color-default">Add</span>
              </button>
            </div>
            }

            {mainPart}
            <ConfirmAction id={'remove_user'}/>
            <ConfirmAction
              id={'login_as'}
              title={'Log In As'}
              content={'Are you sure you want to log in as this user?'}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    list: () => {
      fetchUsers()(dispatch)
    },
    moveToView: () => {
      dispatch(push('/pages/user-view'));
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/people-edit/' + id));
    },
    moveToDelete: () => {
      dispatch(push('/pages/job-cards-delete'));
    },
    addNewUser: () => {
      dispatch(push('/pages/user'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
    loginAs: (data) => {
      loginUserById(data.id)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(People);



// WEBPACK FOOTER //
// ./src/containers/People/index.js